const selfTrainingV2 = {
  back: "Atrás",
  import: "Importar",
  import_general_project: "Importar Proyecto General",
  import_my_project: "Importar Mi Proyecto",
  general_projects: "Proyectos Generales",
  my_projects: "Mis Proyectos",
  legacy_projects: "Proyectos de legado",
  import_legacy_projects: "Importar proyectos heredados",
  import_legacy_projects_descripton:
    "Se importarán los modelos de Autoentrenamiento V1. ¿Desea continuar?",
  successfully_imported: "Se importaron correctamente los proyectos heredados",
  no_legacy_models_to_import: "No hay modelos heredados para importar.",
  general_project: "Proyecto General",
  source_project: "Proyecto Origen",
  select_general_project: "Seleccionar Proyecto General",
  select_source_project: "Seleccionar proyecto origen",
  general_project_required: "El proyecto general es obligatorio",
  source_project_required: "El proyecto origen es obligatorio",
  project_imported_success: "Proyecto importado correctamente",
  training_history: "Historial de Entrenamiento",
  no_training_history: "Aún no hay historial de entrenamiento",
  source_project_not_trained: "El proyecto de origen no está entrenado",
  started_by: "Iniciado por",
  started_on: "Iniciado el",
  completed_on: "Completado el",
  model_id: "Modelo",
  documents_label: "Documentos",
  projects_heading: "Proyectos",
  something_went_wrong: "Algo salió mal. Por favor, inténtelo de nuevo.",
  permission_not_granted: "No tiene permiso para realizar esta acción.",
  no_permission: "No tiene permiso para ver esta página.",
  project_training_in_progress:
    "El entrenamiento del proyecto ya está en progreso.",
  project_analyzing_in_progress:
    "El análisis del proyecto ya está en progreso.",
  project_min_documents_required:
    "Se requiere un número mínimo de 5 documentos para iniciar el entrenamiento.",
  history_error: "Error",
  delete_field_title: "¿Eliminar este campo?",
  delete_field_message: "¿Está seguro de que desea eliminar este campo?",
  delete_document_title: "¿Eliminar este documento?",
  delete_document_message:
    "¿Está seguro de que desea eliminar este documento? Esta acción no se puede deshacer.",
  document_deleted_success: "Documento eliminado correctamente",
  yes: "Sí",
  no: "No",
  reviewToolbar: {
    save: "Guardar",
    download_document: "Descargar documento",
    previous_page: "Página anterior",
    next_page: "Página siguiente",
    zoomin: "Acercar",
    zoomout: "Alejar",
    deselect_multiple: "Selección de campo libre",
    select_feilds_one_by_one:
      "Haz clic para seleccionar los campos uno por uno.",
    drage_select_multiple: "Arrastrar para seleccionar múltiples campos",
    bulk_select_items: "Selección masiva de artículos",
    Rotate_document: "Rotar documento",
    done: "Hecho",
    hide_info: "Ocultar información",
    show_info: "Mostrar información",
  },
  documents: {
    title: "Documentos",
    upload: "Subir Documento",
    single_upload: "Subir Individual",
    bulk_upload: "Subir en Lote",
    bulk_upload_success: "Documentos subidos correctamente",
    bulk_max_reached: "Se alcanzó el máximo de 10 archivos",
    drop_files_here: "Suelta los archivos aquí...",
    drag_or_click:
      "Arrastra y suelta archivos aquí, o haz clic para seleccionar",
    max_files: "Máximo {max} archivos",
    selected_files: "Archivos Seleccionados",
    slots_remaining: "más permitidos",
    select: "Seleccionar Documento",
    select_to_preview: "Seleccione un documento para previsualizar",
    uploaded_count: "subidos",
    analyzed_count: "analizados",
    no_documents: "Aún no se han subido documentos",
    upload_hint: "Sube al menos 5 documentos para habilitar el análisis",
    min_docs_required: "Sube al menos 5 documentos antes de analizar",
    actions: "Acciones",
    edit_project: "Editar Proyecto",
    analyze_btn: "Analizar",
    analyze_started: "Análisis iniciado correctamente",
    analyze_in_progress: "El análisis del proyecto ya está en curso",
    already_analyzed: "Los documentos ya están analizados",
    analyze_first: "Analiza los documentos antes de revisar",
    training_btn: "Iniciar Entrenamiento",
    training_started: "Entrenamiento iniciado correctamente",
    training_hint: "Analiza y revisa los documentos primero antes de entrenar",
    document_not_analyzed:
      "Este documento no ha sido analizado aún. Ejecute Analizar primero.",
    training_completed_at: `Entrenamiento completado el`,
    current_model: `Modelo actual`,
    no_documents_found: "No se encontraron documentos",
    no_model_yet: "Aún no hay modelo entrenado",
    updated_by: "Actualizado por",
    on: "el",
    ignore_duplicate: "Ignorar duplicado",
    reason_to_ignore_duplicate: "Motivo para ignorar el duplicado",
    reason_to_ignore_duplicate_required: "El motivo para ignorar el duplicado es obligatorio",
  },
  review: {
    save: "Guardar",
    saving: "Guardando",
    no_fields: "No se extrajeron campos para este documento",
    analyze_first:
      "Documento no analizado. Por favor, ejecute Analizar en este proyecto primero.",
    no_page_image: "No hay imagen de página disponible",
    doc_type: "Filtrar campos obligatorios por clase de documento",
    doc_type_placeholder: "Seleccionar tipo de documento",
    general: "General",
    row: "Fila",
    table: "Tabla",
    label: "Etiqueta",
    value: "Valor",
    row_number: "Número de fila",
    row_number_start: "Inicio de número de fila (1 - {{itemsLen}})",
    row_number_end: "Fin de número de fila (1 - {{itemsLen}})",
    field_required: "El campo es obligatorio",
    itemindex_required: "El número de fila es obligatorio",
    item_required: "El campo es obligatorio",
    remove: "Eliminar",
    insert_as_new_row: "Insertar como nueva fila",
    bulk_assign: "Asignación Masiva",
    selected_text: "Texto seleccionado",
    assign_field: "Asignar Campo",
    assign_to_field: "Asignar al campo",
    table_name: "Tabla",
    item_field: "Campo",
    row_from: "Fila desde",
    row_to: "Fila hasta",
    auto_fill: "Auto-llenado",
    areas_selected: "elemento(s)",
    rows: "fila(s)",
    field_name: "Nombre del campo",
    required: "Obligatorio",
    no_rows: "Sin filas",
    empty_row: "Fila vacía",
    line: "Línea",
    action: "Acción",
    add_row: "Agregar fila",
    insert_new_rows: "Insertar nueva(s) fila(s)",
    row_number_optional: "Número de fila (Opcional)",
    row_count_optional: "Cantidad de filas (Opcional)",
    insert_at_row: "Insertar en fila (1 a {{max}})",
    insert: "Insertar",
    delete_row_title: "¿Eliminar esta fila?",
    delete_row_message: "¿Está seguro de que desea eliminar esta fila?",
    cancel: "Cancelar",
    view_table: "Ver tabla",
  },
  status: {
    Draft: "Borrador",
    Pending: "Pendiente",
    Analyzing: "Analizando",
    Analyzed: "Analizado",
    Training: "Entrenando",
    Trained: "Entrenado",
    Failed: "Fallido",
  },
  projects: {
    title: "Auto Entrenamiento V2",
    add_project: "Agregar Proyecto",
    edit_project: "Editar Proyecto",
    delete_project: "Eliminar Proyecto",
    project_name: "Nombre del Proyecto",
    description: "Descripción",
    tags: "Etiquetas",
    import_general_project: "Importar Proyecto General",
    select_general_project: "Seleccionar Proyecto General",
    general_project: "Proyecto General",
    project_created_success: "Proyecto creado correctamente",
    project_updated_success: "Proyecto actualizado correctamente",
    project_deleted_success: "Proyecto eliminado correctamente",
    project_imported_success: "Proyecto importado correctamente",
    no_projects_found: "No se encontraron proyectos",
    confirm_delete: "¿Está seguro de que desea eliminar este proyecto?",
    created_on: "Creado el",
    updated_on: "Actualizado el",
    status: "Estado",
    successfully_deleted: "Eliminado correctamente",
    training_status: {
      idle: "Inactivo",
      start_training: "Iniciar Entrenamiento",
      training: "Entrenando",
      trained: "Entrenado",
      failed: "Fallido",
      start_analyzing: "Iniciar Análisis",
      analyzing: "Analizando",
      analyzed: "Analizado",
    },
  },
};

export default selfTrainingV2;
